<template>
  <div>
   
    <div class="row">
      <div class="col-md-12 text-center ">
          <p-checkbox
                  @input="changeType()"
                  key="COUPON"
                  v-model="addcoupon" 
                  class="text-purple"
                  label="Add Coupon">
            <h4 ref="COUPON" class="coupon-selection" :class="activeButton == 'COUPON' ? 'purple' : 'gray'" name="coupon_option">{{$t('marketingCampaigns.addCoupon')}}</h4>
          </p-checkbox>

<!--           <h4  @click="changeType('COUPON')" ref="COUPON" class="coupon-selection" :class="activeButton == 'COUPON' ? 'purple' : 'gray'" name="coupon_option">Coupon</h4>
          <h4  @click="changeType('TEXT')" ref="NOCOUPON" class="coupon-selection" :class="activeButton == 'TEXT' ? 'purple' : 'gray'" name="coupon_option" >No Coupon</h4> -->
      </div>
      <div :disabled="model.type != 'COUPON'">
        <div class="col-md-12 pad-bt-15 text-center">
          <label class="pad-rg-5 valign-top">{{$t('marketingCampaigns.applyTo')}}:</label> 
          <p-radio v-for="(type, key) in couponUsageTypes"
                :key="key"
                v-model="coupons.usage_type"
                v-validate="modelValidations.usage_type"
                :label="key"
                :inline="true"
                :disabled="model.type != 'COUPON'">{{$t('marketingCampaigns.'+type)}}</p-radio>
        </div>
        <div :class="coupons.usage_type == 'PRODUCTS' ? '' : 'col-md-offset-3'" class="col-md-6 ">
          <div class="form-group">
            <label>{{$t('marketingCampaigns.value')}} ({{coupons.type != 'FIXED' ? '%' : currency}})</label>
            <input type="number"
                   min="0" 
                   :placeholder="$t('marketingCampaigns.value')" 
                   v-validate="modelValidations.discount"
                   v-model="coupons.discount"
                   class="form-control"
                   :disabled="model.type != 'COUPON'">
            <small class="text-danger" v-if="errors.discount">
              {{ getError('discount') }}
            </small>
            <br/>
            <p-radio v-for="(type, key) in couponType"
                v-model="coupons.type"
                v-validate="modelValidations.type"
                :key="key"
                :label="key"
                :disabled="model.type != 'COUPON'"
                :inline="true">{{$t('couponsTypes.' + key)}}</p-radio>
          
          </div>
          <div class="form-group">
            <label>{{$t('marketingCampaigns.code')}}</label>
            <input type="text"
                   :placeholder="$t('marketingCampaigns.code')" 
                   v-validate="modelValidations.coupon_code"
                   v-model="coupons.coupon_code"
                   ref="couponCode"
                   :disabled="model.type != 'COUPON'"
                   class="form-control">
            <small class="text-danger" v-if="errors.coupon_code">
              {{ getError('coupon_code') }}
            </small>
            <button :disabled="model.type != 'COUPON'" class="btn btn-purple mar-to-10 mar-bt-10 generate-code" @click.prevent="generateCode()">{{$t('marketingCampaigns.generateCode')}}</button>
          </div>
        </div>
        <div class="col-md-6 icon-search" v-if="coupons.usage_type == 'PRODUCTS'">
          <label>{{$t('marketingCampaigns.chooseCategProduct')}}</label>
          <input type="text" v-model="searchword" placeholder="Search" class="form-control " @input="search" />
          <v-tree ref='tree' :data='treeData' :multiple='true' :halfcheck='true'/> 
        </div>
      </div>
     
    </div>
    
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Radio} from 'element-ui'
  import {mapFields} from 'vee-validate'
  // import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import 'vue-tree-halower/dist/halower-tree.min.css' // you can customize the style of the tree
  // import VTree from 'vue-tree-halower'

  Vue.use(Radio)

  export default {
    props: {
      modelFromParent: {
        type: [Object, Array],
        required: true
      },
      couponsParent: {
        type: [Object, Array],
        required: true
      },
      groupedProductsParent: {
        type: [Object, Array],
        required: true
      }
    },
    watch: {
      modelFromParent (value, oldVal) {
        this.activeButton = value.type
        this.addcoupon = (value.type === 'COUPON')
        this.model = value
      },
      couponsParent (value, oldVal) {
        console.warn('----coupons----')
        console.warn(value)
        this.coupons = value
        this.getTrees()
      },
      groupedProductsParent (value, oldVal) {
        this.groupedProducts = value
        // this.getTrees()
      }
    },
    computed: {
      ...mapFields(['firstName', 'lastName', 'email'])
    },
    created: function () {
      this.currency = this.getCurrencySymbol(this.$session.get('selectedCompanyData').currency_iso)
    },
    data () {
      return {
        model: this.value || this.modelFromParent,
        groupedProducts: this.value || this.groupedProductsParent,
        modelValidations: {
          type: {
            required: true
          },
          usage_type: {
            required: true
          },
          discount: {
            required: true,
            min_value: 1
          },
          coupon_code: {
            required: true,
            min: 4
          }
        },
        coupons: this.value || this.couponsParent,
        couponType: this.$session.get('defaultData')['coupons_types'],
        couponUsageTypes: this.$session.get('defaultData')['coupons_usage_types'],
        pickerOptions1: {},
        pickerNames: ['date_from', 'date_to'],
        searchword: '',
        activeButton: 0,
        addcoupon: false,
        treeData: [],
        currency: ''
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        return this.$validator.validateAll()
      },
      changeType () {
        let newType = 'TEXT'
        if (this.addcoupon) {
          newType = 'COUPON'
          this.getTrees()
        }
        this.model['type'] = newType
        this.activeButton = newType
      },
      search () {
        this.$refs.tree.searchNodes(this.searchword)
      },
      generateCode () {
        console.warn(this.coupons)
        var random = Math.random().toString(36).substring(7)
        var value = this.model.coupon_value

        if (this.coupons['type'] === undefined) {
          this.coupons['type'] = 'PERCENTAGE'
        }
        this.coupons['coupon_code'] = ''
        this.coupons['coupon_code'] = random

        this.$nextTick(function () {
          console.warn(this.coupons)
        })
      },
      getTrees () {
        this.$nextTick(function () {
          var catProdTree = []
          this.treeData = []
          console.warn('-----------TREE----------')
          console.warn(this.groupedProducts)
          console.warn(this.coupons.usage_for_categories)
          for (var id in this.groupedProducts) {
            console.warn(id)
            let idCateg = this.isInObject(parseInt(id), this.coupons.usage_for_categories)
            if (idCateg) {
              let data = {'id': id, 'title': this.groupedProducts[id].details.name, 'checked': true}
              let children = []
              for (let idx in this.groupedProducts[id].items) {
                children.push({'id': this.groupedProducts[id].items[idx].id, 'title': this.groupedProducts[id].items[idx].name, 'checked': true})
              }
              data['children'] = children
              catProdTree.push(data)
            } else {
              // handle children
              let children = []
              let halfcheck = false
              for (let idx in this.groupedProducts[id].items) {
                let chk = false
                let idProd = this.isInObject(parseInt(this.groupedProducts[id].items[idx].id), this.coupons.usage_for_products)
                if (idProd) {
                  chk = true
                  halfcheck = true
                }
                children.push({
                  'id': this.groupedProducts[id].items[idx].id,
                  'title': this.groupedProducts[id].items[idx].name,
                  'checked': chk
                })
              }
              catProdTree.push({'id': id, 'title': this.groupedProducts[id].details.name, 'children': children, 'halfcheck': halfcheck})
            }
          }
          this.treeData = catProdTree
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Campaigns/Steps/ForthStep.vue